var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterVectors(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 377,
    height: 90,
    viewBox: "0 0 377 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.6,
    clipPath: "url(#clip0_2860_12569)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M152.746 0.428287C127.977 0.428285 107.898 20.4236 107.898 45.0891C107.898 69.7546 127.977 89.75 152.746 89.75C177.515 89.75 197.594 69.7546 197.594 45.0891C197.594 20.4236 177.515 0.42829 152.746 0.428287Z",
    fill: "#B7CCFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M377 89.75L287.297 0.421249L287.297 89.75L377 89.75Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M287.305 6.00361L287.305 0.421875L197.602 0.421867L197.602 6.0036L287.305 6.00361Z",
    fill: "#F6F8FE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M197.594 19.9609L287.297 19.9609L287.297 14.3792L197.594 14.3792L197.594 19.9609Z",
    fill: "#F6F8FE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M197.594 33.9219L287.297 33.9219L287.297 28.3402L197.594 28.3401L197.594 33.9219Z",
    fill: "#F6F8FE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M197.594 47.875L287.297 47.875L287.297 42.2933L197.594 42.2933L197.594 47.875Z",
    fill: "#F6F8FE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M197.594 61.8359L287.297 61.8359L287.297 56.2542L197.594 56.2542L197.594 61.8359Z",
    fill: "#F6F8FE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M197.594 75.7969L287.297 75.7969L287.297 70.2152L197.594 70.2151L197.594 75.7969Z",
    fill: "#F6F8FE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M287.312 89.7536L287.312 84.1719L197.609 84.1719L197.609 89.7536L287.312 89.7536Z",
    fill: "#F6F8FE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0426 0.428287C38.2737 0.428285 18.1945 20.4236 18.1945 45.0891C18.1945 69.7546 38.2737 89.75 63.0426 89.75C87.8115 89.75 107.891 69.7546 107.891 45.0891C107.891 20.4236 87.8115 0.42829 63.0426 0.428287Z",
    fill: "#E7EDFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.42543 89.75L4.17969 89.75L4.1797 0.421257L-1.42542 0.421257L-1.42543 89.75Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1989 0.414063L12.5938 0.414062L12.5937 89.7428L18.1989 89.7428L18.1989 0.414063Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2860_12569"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 89,
    height: 377,
    fill: "white",
    transform: "translate(377 0.75) rotate(90)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterVectors);
export default __webpack_public_path__ + "static/media/FooterVectors.df68b72dbac4f8cd6473b1636c6875e1.svg";
export { ForwardRef as ReactComponent };